import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { uploadSiteImage } from "@/lib/supabase";
import { useLocations, useInvalidate } from "@/lib/siteData";
import { Card, Field, Area, Toggle, SaveBtn, DelBtn, Err } from "./adminUI";

function LocationRow({ loc }) {
    const invalidate = useInvalidate();
    const [form, setForm] = useState({ ...loc });
    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState("");

    const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

    const save = async () => {
        setSaving(true);
        setErr("");
        const { error } = await supabase
            .from("locations")
            .update({
                name: form.name,
                description: form.description,
                image_url: form.image_url,
                sort_order: Number(form.sort_order) || 0,
                active: form.active,
            })
            .eq("id", loc.id);
        setSaving(false);
        if (error) setErr("Erro: " + error.message);
        else invalidate("locations");
    };

    const remove = async () => {
        if (!window.confirm(`Excluir o local "${form.name}"?`)) return;
        const { error } = await supabase
            .from("locations")
            .delete()
            .eq("id", loc.id);
        if (error) setErr("Erro: " + error.message);
        else invalidate("locations");
    };

    const upload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        try {
            const url = await uploadSiteImage(file, "locations");
            set("image_url")(url);
        } catch (ex) {
            setErr("Erro no upload: " + ex.message);
        }
    };

    return (
        <Card className="space-y-4">
            <div className="flex flex-wrap items-center justify-between gap-3">
                <Toggle
                    checked={form.active}
                    onChange={set("active")}
                    label={form.active ? "Ativo" : "Inativo"}
                    testid={`location-active-${loc.id}`}
                />
                <DelBtn onClick={remove} testid={`location-delete-${loc.id}`} />
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <Field label="Nome" value={form.name} onChange={set("name")} testid={`location-name-${loc.id}`} />
                <Field label="Ordem de exibição" type="number" value={form.sort_order} onChange={set("sort_order")} testid={`location-order-${loc.id}`} />
            </div>
            <Area label="Descrição" value={form.description} onChange={set("description")} testid={`location-desc-${loc.id}`} />
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <Field label="URL da imagem" value={form.image_url} onChange={set("image_url")} testid={`location-imgurl-${loc.id}`} />
                <label className="block">
                    <span className="font-mono2 text-[10px] font-semibold uppercase tracking-[0.25em] text-neon-cyan">
                        Enviar imagem
                    </span>
                    <input
                        type="file"
                        accept="image/*"
                        data-testid={`location-upload-${loc.id}`}
                        onChange={upload}
                        className="mt-2 block w-full text-sm text-dim file:mr-3 file:rounded-full file:border-0 file:bg-neon-cyan/10 file:px-4 file:py-2 file:font-mono2 file:text-[10px] file:uppercase file:tracking-[0.2em] file:text-neon-cyan"
                    />
                </label>
            </div>
            <div className="flex items-center justify-end gap-4">
                <Err msg={err} />
                <SaveBtn onClick={save} saving={saving} testid={`location-save-${loc.id}`} />
            </div>
        </Card>
    );
}

export default function LocationsAdmin() {
    const locations = useLocations(true);
    const invalidate = useInvalidate();
    const [err, setErr] = useState("");

    const create = async () => {
        setErr("");
        const { error } = await supabase
            .from("locations")
            .insert({ name: "Novo local", sort_order: 0, active: false });
        if (error) setErr("Erro ao criar: " + error.message);
        else invalidate("locations");
    };

    return (
        <div className="space-y-8">
            <div className="flex flex-wrap items-center justify-between gap-4">
                <div>
                    <h1 className="font-display text-2xl font-black uppercase sm:text-3xl">
                        Locais
                    </h1>
                    <p className="mt-2 text-sm text-dim">
                        Praias e locais exibidos na seção de passeios. Ative
                        para aparecer no site.
                    </p>
                </div>
                <button
                    onClick={create}
                    data-testid="locations-create"
                    className="rounded-full bg-neon-teal px-6 py-2.5 font-display text-[10px] font-extrabold uppercase tracking-widest text-ocean transition-transform hover:scale-105"
                >
                    + Cadastrar local
                </button>
            </div>
            <Err msg={err} />
            {locations.map((l) => (
                <LocationRow key={l.id} loc={l} />
            ))}
        </div>
    );
}
